import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/app/Layout";
import Dashboard from "@/pages/Dashboard";
import Jobs from "@/pages/Jobs";
import Employees from "@/pages/Employees";
import Customers from "@/pages/Customers";
import Finances from "@/pages/Finances";
import CalendarPage from "@/pages/CalendarPage";
import Payroll from "@/pages/Payroll";
import WhatsAppPage from "@/pages/WhatsAppPage";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-emerald-600" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="isler" element={<Jobs />} />
            <Route path="calisanlar" element={<Employees />} />
            <Route path="musteriler" element={<Customers />} />
            <Route path="finans" element={<Finances />} />
            <Route path="takvim" element={<CalendarPage />} />
            <Route path="hakedis" element={<Payroll />} />
            <Route path="whatsapp" element={<WhatsAppPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
